import { BillingTermsCard } from './BillingTermsCard';

export { BillingTermsCard };
